module.exports = __webpack_public_path__ + "img/Efdot-Hat-02@2x.9be138b8.jpg";